import { OverseasCompanyData } from '../../../../../types/api'
import { CardTitle } from '../../../../atoms/CardTitle'
import { OverseasCompanyFundingRounds } from './OverseasCompanyFundingRounds'

type Props = {
  overseaFundingRounds: OverseasCompanyData['overseaFundingRounds']
}

export const OverseasCompanyFinance: React.FC<Props> = ({
  overseaFundingRounds,
}) => {
  return (
    <div className="finance">
      <CardTitle>ファイナンス</CardTitle>
      <OverseasCompanyFundingRounds
        overseaFundingRounds={overseaFundingRounds}
      />
    </div>
  )
}
